import type { LineUsage } from '@erp/rpc';

/** Which figure a usage column shows: the location's own, or what rolls up to it. */
export type UsagePart = 'own' | 'dependent';

/** The figure a usage column shows and sorts by; null when it shows none. */
export function usageQuantity(
  usage: LineUsage | null,
  part: UsagePart = 'own',
): number | null {
  if (usage?.availability !== 'available') return null;
  return part === 'own'
    ? usage.ownQuantity
    : (usage.dependent?.quantity ?? null);
}
